import { upsellProduct } from "./snippets/upsell-product";

upsellProduct.init();
